'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import { findDOMNode } from 'react-dom';
/**
 * Radial progress bar. Pass in 'score' prop (0 -> 100) to set the
 * value of the progress bar. Any 'children' HTML will be put inside the
 * radial.
 */

var RadialProgressBar = /*#__PURE__*/function (_Component) {
  _inherits(RadialProgressBar, _Component);

  function RadialProgressBar() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, RadialProgressBar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(RadialProgressBar)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.alignProgressBar = function (score) {
      var changeTrasformRotateZ = function changeTrasformRotateZ(element, deg) {
        findDOMNode(element).style.transform = "rotateZ(" + deg + "deg)";
        findDOMNode(element).style.webkitTransform = "rotateZ(" + deg + "deg)";
      };

      if (score <= 66) {
        var leftDeg = -Math.abs(180 - Math.round(2.7 * score)); // No need to move the right, only the left

        changeTrasformRotateZ(_this.refs.leftSectionWedge, leftDeg);
        changeTrasformRotateZ(_this.refs.markerEnd, leftDeg);
      } else {
        // Bring the left section up to full
        changeTrasformRotateZ(_this.refs.leftSectionWedge, 0);
        var rightDeg = -90 - (100 - score) * 2.7; // Move the right section

        changeTrasformRotateZ(_this.refs.rightSectionWedge, rightDeg);
        changeTrasformRotateZ(_this.refs.markerEnd, 180 + rightDeg);
      }
    };

    return _this;
  }

  _createClass(RadialProgressBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var score = parseInt(this.props.score, 10);
      this.alignProgressBar(score);
    }
    /**
     * Align the progress bar with the score prop passed in.
     */

  }, {
    key: "render",

    /**
     * Change the transform prop of the element, rotating the Z axis.
     */
    value: function render() {
      return /*#__PURE__*/_jsxs("div", {
        "data-vr-ignore": true,
        className: "radial-container",
        "data-reagan-selector": "radial-container",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "radial-wrapper",
          children: [/*#__PURE__*/_jsx("div", {
            className: "radial-section radial-right-section",
            children: /*#__PURE__*/_jsx("div", {
              className: "wedge"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "radial-section radial-left-section",
            children: /*#__PURE__*/_jsx("div", {
              className: "wedge"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "marker start"
          }), /*#__PURE__*/_jsx("div", {
            className: "marker end"
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "radial-wrapper radial-progress-wrapper",
          children: [/*#__PURE__*/_jsx("div", {
            className: "radial-section radial-right-section",
            children: /*#__PURE__*/_jsx("div", {
              className: "wedge",
              ref: "rightSectionWedge"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "radial-section radial-left-section",
            children: /*#__PURE__*/_jsx("div", {
              className: "wedge",
              ref: "leftSectionWedge"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "marker start"
          }), /*#__PURE__*/_jsx("div", {
            className: "marker end",
            ref: "markerEnd"
          }), /*#__PURE__*/_jsx("div", {
            className: "radial-inner-container",
            children: this.props.children
          })]
        })]
      });
    }
  }]);

  return RadialProgressBar;
}(Component);

export { RadialProgressBar as default };